import { crv, cva } from '@/styled-system/css';

export const paginationReadoutRecipe = cva({
  variants: {
    ...crv('showNumberButtons', {
      false: {
        display: 'block',
        flexGrow: 1,
        flexShrink: 0,
        textAlign: 'center',
      },
      true: {
        display: 'none',
      },
    }),
  },
});
